<template>
  <div>
    <b-modal
      ref="mdlPacienteFormulario"
      :title="title"
      ok-title="Salvar"
      cancel-title="Cancelar"
      size="lg"
      @ok.prevent="salvar"
      @hidden="limpar"
      @shown="validacao"
      centered
      class="modal-tabs"
      scrollable
    >
      <form ref="frmPacienteFormulario">
        <b-tabs content-class="p-7">
          <b-tab title="Dados Pessoais" active>
            <b-row>
              <b-col cols="4">
                <b-form-group label="CPF:" label-for="atendimento-cpf">
                  <b-form-input
                    id="atendimento-cpf"
                    name="cpf"
                    v-model="formulario.cpf"
                    size="sm"
                    data-inputmask="'alias': 'cpf'"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Nome:" label-for="atendimento-nome">
                  <b-form-input
                    id="atendimento-nome"
                    name="nome"
                    v-model="formulario.nome"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Data de nascimento:"
                  label-for="atendimento-data-nascimento"
                >
                  <b-form-input
                    id="atendimento-data-nascimento"
                    name="data_nascimento"
                    v-model="formulario.data_nascimento"
                    size="sm"
                    type="date"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Cartão do SUS:"
                  label-for="atendimento-cartao-sus"
                >
                  <b-form-input
                    id="atendimento-cartao-sus"
                    name="cartao_sus"
                    v-model="formulario.cartao_sus"
                    size="sm"
                    data-inputmask="'alias': 'cartao_sus'"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Cor:" label-for="atendimento-cor">
                  <b-select
                    id="atendimento-cor"
                    name="cor"
                    v-model="formulario.cor"
                    size="sm"
                  >
                    <option value="branco">Branco</option>
                    <option value="negro">Negro</option>
                    <option value="pardo">Pardo</option>
                    <option value="amarelo">Amarelo</option>
                    <option value="indigena">Indígena</option>
                  </b-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Nome social:"
                  label-for="atendimento-nome-social"
                >
                  <b-form-input
                    id="atendimento-nome-social"
                    name="nome_social"
                    v-model="formulario.nome_social"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group label="Sexo:" label-for="atendimento-sexo">
                  <b-form-select
                    id="atendimento-sexo"
                    name="sexo"
                    v-model="formulario.sexo"
                    size="sm"
                  >
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                    <option value="N">Não informado</option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group label="PCD:" label-for="atendimento-pcd">
                  <b-form-select
                    id="atendimento-pcd"
                    name="pcd"
                    v-model="formulario.pcd"
                    size="sm"
                  >
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="formulario.pcd === 'S'">
              <b-col>
                <b-form-group
                  label="Descrição PCD:"
                  label-for="atendimento-descricao-pcd"
                >
                  <b-form-input
                    id="atendimento-descricao-pcd"
                    name="descricao_pcd"
                    v-model="formulario.descricao_pcd"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Endereço">
            <b-row>
              <b-col cols="3">
                <b-form-group label="CEP:" label-for="atendimento-cep">
                  <b-input-group>
                    <b-form-input
                      id="atendimento-cep"
                      name="cep"
                      v-model="formulario.cep"
                      size="sm"
                      data-inputmask="'alias': 'cep'"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" @click="buscarCep" variant="primary">
                        <b-icon-search></b-icon-search>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group
                  label="Tipo de logradouro:"
                  label-for="atendimento-tipo-logradouro"
                >
                  <b-select
                    id="atendimento-tipo-logradouro"
                    name="tipo_logradouro_id"
                    v-model="formulario.tipo_logradouro_id"
                    size="sm"
                  >
                    <option
                      v-for="tipo in tiposLogradouro"
                      :key="tipo.id"
                      :value="tipo.id"
                    >
                      {{ tipo.descricao }}
                    </option>
                  </b-select>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Endereço:"
                  label-for="atendimento-endereco"
                >
                  <b-form-input
                    id="atendimento-endereco"
                    name="endereco"
                    v-model="formulario.endereco"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="3">
                <b-form-group
                  label="Número:"
                  label-for="atendimento-numero-endereco"
                >
                  <b-form-input
                    id="atendimento-numero-endereco"
                    name="numero_endereco"
                    v-model="formulario.numero_endereco"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Bairro:" label-for="atendimento-bairro">
                  <b-form-input
                    id="atendimento-bairro"
                    name="bairro"
                    v-model="formulario.bairro"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  label="Complemento:"
                  label-for="atendimento-complemento"
                >
                  <b-form-input
                    id="atendimento-complemento"
                    name="complemento"
                    v-model="formulario.complemento"
                    size="sm"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group label="Estado:" label-for="atendimento-estado">
                  <b-select
                    id="atendimento-estado"
                    name="estado_id"
                    v-model="formulario.estado_id"
                    size="sm"
                    @change="estadoAtualizado"
                  >
                    <option
                      v-for="estado in estados"
                      :key="estado.id"
                      :value="estado.id"
                    >
                      {{ estado.nome }}
                    </option>
                  </b-select>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Cidade:" label-for="atendimento-cidade">
                  <b-select
                    id="atendimento-cidade"
                    name="cidade_id"
                    v-model="formulario.cidade_id"
                    size="sm"
                  >
                    <option
                      v-for="cidade in cidadesPorEstado"
                      :key="cidade.id"
                      :value="cidade.id"
                    >
                      {{ cidade.nome }}
                    </option>
                  </b-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Contatos">
            <b-row>
              <b-col>
                <b-form-group
                  label="Telefone:"
                  label-for="atendimento-telefone"
                >
                  <b-form-input
                    id="atendimento-telefone"
                    name="telefone"
                    v-model="formulario.telefone"
                    size="sm"
                    data-inputmask="'alias': 'telefone'"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Celular:" label-for="atendimento-celular">
                  <b-form-input
                    id="atendimento-celular"
                    name="celular"
                    v-model="formulario.celular"
                    size="sm"
                    data-inputmask="'alias': 'celular'"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Email:" label-for="atendimento-email">
                  <b-form-input
                    id="atendimento-email"
                    name="email"
                    v-model="formulario.email"
                    size="sm"
                    data-inputmask="'alias': 'email'"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </form>
    </b-modal>
  </div>
</template>

<script>
import PacienteService from "@/core/services/paciente.service";
import EstadoService from "@/core/services/estado.service";
import CidadeService from "@/core/services/cidade.service";
import TipoLogradouroService from "@/core/services/tipologradouro.service";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import Swal from "sweetalert2";
import Inputmask from "@/core/plugins/inputmask";

export default {
  name: "paciente-formulario",

  data() {
    return {
      formulario: {
        id: null,
        nome: "",
        cpf: "",
        cep: "",
        tipo_logradouro_id: null,
        endereco: "",
        numero_endereco: "",
        complemento_endereco: "",
        bairro: "",
        cidade_id: null,
        estado_id: null,
        data_nascimento: "",
        cartao_sus: "",
        cor: "",
        telefone: "",
        celular: "",
        email: "",
        nome_social: "",
        sexo: "N",
        pcd: "N",
        descricao_pcd: "",
      },
      estados: [],
      cidades: [],
      tiposLogradouro: [],
    };
  },

  async mounted() {
    await EstadoService.getEstados().then((response) => {
      this.estados = response.data;
    });

    await CidadeService.getCidades().then((response) => {
      this.cidades = response.data;
    });

    await TipoLogradouroService.getTipos().then((response) => {
      this.tiposLogradouro = response.data;
    });
  },

  methods: {
    exibirModal(paciente) {
      if (paciente) {
        this.formulario.id = paciente.id;
        this.formulario.nome = paciente.nome;
        this.formulario.cpf = paciente.cpf;
        this.formulario.cep = paciente.cep;
        this.formulario.tipo_logradouro_id = paciente.tipo_logradouro_id;
        this.formulario.endereco = paciente.endereco;
        this.formulario.numero_endereco = paciente.numero_endereco;
        this.formulario.bairro = paciente.bairro;
        this.formulario.complemento = paciente.complemento;
        this.formulario.estado_id = paciente.estado_id;
        this.formulario.cidade_id = paciente.cidade_id;
        this.formulario.data_nascimento = paciente.data_nascimento;
        this.formulario.cartao_sus = paciente.cartao_sus;
        this.formulario.cor = paciente.cor;
        this.formulario.telefone = paciente.telefone;
        this.formulario.celular = paciente.celular;
        this.formulario.email = paciente.email;
        this.formulario.nome_social = paciente.nome_social;
        this.formulario.sexo = paciente.sexo || "N";
        this.formulario.pcd = paciente.pcd;
        this.formulario.descricao_pcd = paciente.descricao_pcd;
      }

      this.$refs.mdlPacienteFormulario.show();
    },

    async salvar() {
      let formulario = { ...this.formulario };

      await this.fv.validate().then((status) => {
        if (status === "Valid") {
          PacienteService.salvar(formulario)
            .then(({ data }) => {
              this.$emit("atualizar");
              this.$emit("paciente-cadastrado", data.paciente);
              this.$refs.mdlPacienteFormulario.hide();

              Swal.fire({
                icon: "success",
                title: "Sucesso!",
                text: "Paciente salvo com sucesso.",
              });
            })
            .catch((error) => {
              if (error.response.status === 422) {
                Object.entries(error.response.data.errors).forEach(
                  ([key, value]) => {
                    this.fv
                      .updateValidatorOption(key, "blank", "message", value[0])
                      .updateFieldStatus(key, "Invalid", "blank");
                  }
                );
              }
            });
        }
      });
    },

    validacao() {
      const frmPacienteFormulario = this.$refs.frmPacienteFormulario;
      Inputmask().mask(
        frmPacienteFormulario.querySelectorAll("[data-inputmask]")
      );

      this.fv = formValidation(frmPacienteFormulario, {
        fields: {
          nome: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          cpf: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          tipo_logradouro_id: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          endereco: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          numero_endereco: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          bairro: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          estado_id: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          cidade_id: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          data_nascimento: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          cartao_sus: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          cor: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
          sexo: {
            validators: {
              notEmpty: {
                message: "Preenchimento obrigatório.",
              },
              blank: {},
            },
          },
        },
        plugins: {
          trigger: new Trigger(),
          bootstrap: new Bootstrap(),
        },
      });
    },

    limpar() {
      this.formulario.id = null;
      this.formulario.nome = "";
      this.formulario.cpf = "";
      this.formulario.cep = "";
      this.formulario.tipo_logradouro_id = null;
      this.formulario.endereco = "";
      this.formulario.numero_endereco = "";
      this.formulario.bairro = "";
      this.formulario.complemento = "";
      this.formulario.estado_id = null;
      this.formulario.cidade_id = null;
      this.formulario.data_nascimento = "";
      this.formulario.cartao_sus = "";
      this.formulario.cor = "";
      this.formulario.telefone = "";
      this.formulario.celular = "";
      this.formulario.email = "";
      this.formulario.nome_social = "";
      this.formulario.sexo = "N";
      this.formulario.pcd = "N";
      this.formulario.descricao_pcd = "";
    },

    estadoAtualizado(estado) {
      if (estado !== this.formulario.estado_id) {
        this.formulario.cidade_id = null;
      }
    },

    async buscarCep() {
      const cep = this.formulario.cep.replace(/\D/g, "");

      if (cep.length !== 8) {
        Swal.fire({
          icon: "error",
          title: "CEP inválido",
          text: "O CEP deve conter 8 dígitos.",
        });

        return;
      }
      this.$store.dispatch("toggleOverlay", {
        value: true,
        message: "Processando, aguarde...",
      });

      await new Promise((resolve) => setTimeout(resolve, 1000));

      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      this.$store.dispatch("toggleOverlay", {
        value: false,
      });

      if (data.erro) {
        Swal.fire({
          icon: "error",
          title: "CEP não encontrado",
          text: "O CEP informado não foi encontrado.",
        });

        this.formulario.endereco = "";
        this.formulario.bairro = "";
        this.formulario.cidade_id = null;
        this.formulario.estado_id = null;

        return;
      }

      this.formulario.tipo_logradouro_id =
        this.tiposLogradouro.find(
          (tipo) => tipo.descricao === data.logradouro.split(" ")[0]
        )?.id || null;
      this.formulario.endereco = data.logradouro.split(" ").slice(1).join(" ");
      this.formulario.bairro = data.bairro;
      this.formulario.estado_id =
        this.estados.find((estado) => estado.uf === data.uf)?.id || null;
      this.formulario.cidade_id =
        this.cidades.find(
          (cidade) =>
            cidade.nome === data.localidade &&
            cidade.uf === this.formulario.estado_id
        )?.id || null;

      document.querySelector("#atendimento-numero-endereco").focus();
    },
  },

  computed: {
    title() {
      return this.formulario.id ? "Editar Paciente" : "Novo Paciente";
    },

    cidadesPorEstado() {
      return this.cidades.filter(
        (cidade) => cidade.uf === this.formulario.estado_id
      );
    },
  },

  beforeDestroy: function () {
    if (this.fv) {
      this.fv.destroy();
    }
  },
};
</script>

<style scoped>
/deep/ .custom-checkbox .custom-control-label::before {
  top: 0.1rem !important;
}
/deep/ .custom-checkbox .custom-control-label::after {
  top: 0.1rem !important;
}
/deep/ .modal-body {
  padding: 0 !important;
}
/deep/ .modal-header {
  border-bottom: 0 !important;
}
</style>
